import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationService} from 'primeng/api';
import { ConfirmDialogModule} from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
// import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { ViewNoticeComponent } from './view-notices.component';
import { NoticeService } from '../services/notice.service';
import { LoginRouteGuard } from 'src/app/login-route-guard';


@NgModule({
    imports: [
      CommonModule,
      AccordionModule,
      TableModule,
      FormsModule,
      ToastModule,
      ConfirmDialogModule,
        CalendarModule,
      // ProgressSpinnerModule,
      RouterModule.forChild([
        { path: 'viewnotices', component: ViewNoticeComponent, canActivate: [LoginRouteGuard]},
        { path: '', redirectTo: 'home', pathMatch: 'full'},
        ]),
    ],
    declarations: [
        ViewNoticeComponent
    ],
    providers: [
        MessageService,
        ConfirmationService,
        NoticeService,
    ]
  })
  export class NoticesModule { }
